
import React, { useState } from 'react';
import styled from "styled-components"; 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import GoogleAnalyticsEvent from "../background/GoogleAnalyticsEvent.js";

import { useLocation } from "@reach/router"
import axios from 'axios';
import {GetGUID} from "../background/InterestTracker.js"

import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import FloatingLabel from 'react-bootstrap/FloatingLabel'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Modal from 'react-bootstrap/Modal'
import Spinner from 'react-bootstrap/Spinner'

import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons'

const FormHeadline = styled.div`
    display:block; 
    position:absolute; 
    z-index:1; 
    width:100%; 
    height:84px; 
    overflow:hidden; 
    & > svg{ 
        display:absolute; 
        left:0px; 
        top:0px; 
        z-index:10; 
    }
    & > svg .mainbg {
      fill: #169300;
    }
    & > svg .underborder,
    & > svg .topborder {
      fill: #116000;
    }
    & > h4{ 
        color:#FFFFFF; 
        text-shadow: 2px 2px 0px #000000; 
        z-index:20; 
        position:absolute; 
        top:13px; 
        left:40px; 
    }
`;

const FormBody = styled.div`
    margin:50px 30px 0px 30px; 
    display:block; 
    &.done{ 
        display:none; 
    }

     @media (max-width:991.98px) {  
        & span.text-line{
            display:inline; 
        } 
    }
`; 
const DoneBody = styled.div`
    margin:50px 30px 0px 30px; 
    display:none;
    &.done{ 
        display:block; 
    }

`; 
const FormLabel = styled(Form.Label)`
    font-weight:bold;
`
const FormButton = styled(Button)`
	display:inline; 
	background-color:#008BE0; 
    border:0px; 
    height:40px; 
    margin:20px 20px 10px 0px; 
	border-radius: 20px;
    color: white;
    outline: none;
    font-size:1.1em; 
    padding-right:20px; 
    padding-left:15px; 
    text-align:center; 
    transition: all 0.3s cubic-bezier(.25,.8,.25,1);
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
	&:hover {
        box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);
    }
    &.submit{ 
        width:150px; 
    }
	&.green{ 
		background-color:#169300; 
	} 
	&.green.inverse{ 
        border:1px solid #169300; 
        background-color:#FFFFFF; 
	} 
	&.blue{ 
		background-color:#008BE0; 
	} 
	&.blue.inverse{ 
        background-color:#FFFFFF;
        border:1px solid #008BE0; 
        color:#008BE0; 
	} 
	&.inverse{ 
        background-color:#FFFFFF;
        border:1px solid #008BE0; 
        color:#008BE0; 
	} 
	&.yellow{ 
        background-color:#fcae00; 
        color:#000000; 
	} 
	&.yellow.inverse{ 
        background-color:#FFFFFF;
        border:1px solid #fcae00; 
        color:#fcae00; 
	} 
	&.red{ 
        background-color:#a50000; 
	} 
	&.red.inverse{ 
        background-color:#FFFFFF;
        border:1px solid #a50000; 
        color:#a50000;
	} 
	&.orange{ 
        background-color:#C96E00; 
	} 
	&.orange.inverse{ 
        background-color:#FFFFFF;
        border:1px solid #C96E00; 
        color:#C96E00; 
	} 
	&.purple{ 
        background-color:#7500C9; 
	} 
	&.gray{ 
        background-color:#999999; 
	} 
	&.gray.inverse{ 
        border:1px solid #999999; 
        background-color:#FFFFFF; 
        color:#999999; 
	} 
	&.purple.inverse{ 
        background-color:#FFFFFF;
        border:1px solid #7500C9; 
        color:#7500C9; 
	} 
    &:disabled{ background-color:#999999; box-shadow:none; }
`;

const FormattedFloatingLabel = styled(FloatingLabel)`
    margin-bottom:10px; 
    & > label{ 
        font-style:italic; 
        color:#444; 
    }
`; 
const CheckboxRow = styled(Form.Group)`
    margin-top:0px; 
    color:#999; 
`;

const PhoneRequiredMessage = styled.small`
    padding-left:25px; 
    color:#C96E00; 
    font-weight:bold; 
    display:none; 
    & > span{ 
        display:block; 
    }
    &.show{ 
        display:block; 
    }
`;
const Error = styled.div`
    border:1px solid #a50000;
    color:#a50000; 
    background-color:#ffc5c5; 
    border-radius:10px; 
    padding:10px; 
    display:flex; 
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: flex-start; 
    margin-top:20px; 
    &.validation{ 
        border:1px solid #fcae00; 
        background-color:#efc97b; 
        color:#000; 
    }
    &.validation > svg{ 
        color:#C96E00
    }
    & > svg{ 
        margin-right:10px; 
    }
    & > p{ 
        margin-bottom:0px; 
    }
    & > p > .detail{ 
        font-size:0.8em; 
        display:block; 
    }
`;


export default function ConsultationRequestForm({show,onClose}) {

    const { pathname } = useLocation();
    const { executeRecaptcha } = useGoogleReCaptcha();

    const [name,setName] = useState(''); 
    const [phone,setPhone] = useState(''); 
    const [email,setEmail] = useState(''); 
    const [preferredTime,setPreferredTime] = useState(''); 
    const [preferEmail,setPreferEmail] = useState(false); 
    const [message,setMessage] = useState(''); 

    const [formDone,setFormDone] = useState(false); 
    const [isSendingForm,setIsSendingForm] = useState(false); 
    const [submitErrorMessage,setSubmitErrorMessage] = useState(null); 
    const [submitErrorDetail,setSubmitErrorDetail] = useState(null); 
    const [validationErrorMessage,setValidationErrorMessage] = useState(null); 

    function cancelDialog(){ 
        GoogleAnalyticsEvent("cancel_consultationrequest",{})
        onClose(); 
    }

    function closeDialog(){ 
        setMessage(''); 
        setTimeout(()=>{setFormDone(false);},500);  
        onClose(); 
    }
    function onPhoneInputKeyDown(e){
        let allowedKeyCodes = [8,32,37,38,39,40,48,49,50,51,52,53,54,55,56,57,96,97,98,99,100,101,102,103,104,105,109,189,173]; 
        if(allowedKeyCodes.indexOf(e.which)<0){ e.preventDefault(); }
    };
    function formatPhoneNumber(value) {
        if (!value) return value;

        const phoneNumber = value.replace(/[^\d]/g, "");
        const phoneNumberLength = phoneNumber.length;
        if (phoneNumberLength < 4) return phoneNumber;
        if (phoneNumberLength < 7) {
            return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
        }
        return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
            3,
            6
        )}-${phoneNumber.slice(6, 10)}`;
    }

    function submitForm(){ 

        if(isSendingForm) return false; 

        setSubmitErrorMessage(null); 
        setValidationErrorMessage(null); 
        setSubmitErrorDetail(null); 
        setIsSendingForm(true); 

        let re = /^[^\s@]+@[^\s@]+$/;
        if(email!=="" && !re.test(email)){ 
            GoogleAnalyticsEvent("validation_error", {failure:"email format"}); 
            setIsSendingForm(false); 
            setValidationErrorMessage("Something looks funny about the email address you entered. Please double check it and send again.")
            return false; 
        }
        if(name===""){ 
            GoogleAnalyticsEvent("validation_error", {failure:"empty name"}); 
            setIsSendingForm(false); 
            setValidationErrorMessage("Please enter your name.")
            return false; 
        }
        if(phone==="" && email===""){ 
            GoogleAnalyticsEvent("validation_error", {failure:"empty phone and email"}); 
            setIsSendingForm(false); 
            setValidationErrorMessage("Please enter either your phone number or email address.")
            return false; 
        }
        if(message===""){ 
            GoogleAnalyticsEvent("validation_error", {failure:"empty message"}); 
            setIsSendingForm(false); 
            setValidationErrorMessage("Please tell us a little bit about the trip you're thinking about.")
            return false; 
        }

        var data = {
            email:email,
            phone:phone,
            name:name,
            preferredTime:preferredTime,
            message:message,
            triggerPage:pathname
        }
        
        let guid = GetGUID(); 
        if(guid!==null) data.uuid = guid; 

        data.contactMethod = (preferEmail) ? 'email':'phone'; 

        // data.interests = GetInterests(); 
        // ClearInterests(); 
    
        data.recaptchaToken = executeRecaptcha('consultationRequest'); 


        axios.post(process.env.GATSBY_API_URL+"/website/outward/outward/inquiries",data)
            .then(result => {
                if(result.data.status==='ok'){ 
                    GoogleAnalyticsEvent("generate_lead", {preferredMethod:data.contactMethod}); 
                    setIsSendingForm(false); 
                    setFormDone(true); 
                }  
            }).catch(error => {
                setIsSendingForm(false); 
                if (error.response) {
                    GoogleAnalyticsEvent("lead_submission_error", {errorType:error.response.data.error}); 
                    setSubmitErrorMessage(error.response.data.message); 
                    setSubmitErrorDetail(error.response.data.detail); 
                } else if (error.request) {
                    GoogleAnalyticsEvent("lead_submission_error", {errorType:'server-unresponsive'}); 
                    setSubmitErrorMessage("Sorry, we had trouble saving your consultation request. Please try again or give us a call at (720) 828-7665."); 
                    setSubmitErrorDetail("No response from server."); 
                } else {
                    GoogleAnalyticsEvent("lead_submission_error", {errorType:'axios-error'}); 
                    setSubmitErrorMessage("Sorry, we had trouble saving your consultation request. Please try again or give us a call at (720) 828-7665."); 
                    setSubmitErrorDetail(error.message); 
                }
            });

    }

  return (
    <Modal
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={show}
    >
    <FormHeadline>
        <h4>Request a Free Consultation</h4>
        <svg id="DialogHeader" data-name="Dialog Header" xmlns="http://www.w3.org/2000/svg" width="850" height="84" viewBox="0 0 850 84">
            <path class="mainbg" d="M488,47H46C2,47,0,77,0,77V21S2,5,36,4H513Z"/>
            <path class="underborder" d="M460,49H45C1,49,0,84,0,84S3,54,45,54H457Z"/>
            <path class="topborder" d="M857,0H0V17S2,3,36,2H857Z"/>
        </svg>
    </FormHeadline>
      <Modal.Body>
            <FormBody className={formDone && "done"}>
                <p><span class="text-line">We customize our recommendations to every client's unique interests and needs. </span><span className="text-line">Let's start with a no-obligation and no-pressure chat, or call us at <nobr>(720) 828-7665!</nobr></span></p>
                <p><b>Contact Information</b></p>
                <Row xs={1} sm={1} md={2}>
                    <Col>
                        <FormattedFloatingLabel controlId="consultrequest_name" label="Your name">
                            <Form.Control type="text" placeholder="Your name" value={name} onChange={e => { setName(e.target.value); }}/>
                        </FormattedFloatingLabel>
                    </Col>
                    <Col>
                        <FormattedFloatingLabel controlId="consultrequest_phone" label="Phone number">
                            <Form.Control type="text" placeholder="Phone number" value={phone} onKeyDown={onPhoneInputKeyDown} onChange={e => { 
                                let formattedPhoneNumber = formatPhoneNumber(e.target.value);
                                setPhone(formattedPhoneNumber); }}/>
                        </FormattedFloatingLabel>
                    </Col>
                </Row>
                <FormattedFloatingLabel controlId="consultrequest_email" label="Email address">
                    <Form.Control type="email" placeholder="Email address" value={email} onChange={e => { setEmail(e.target.value); }}/>
                </FormattedFloatingLabel>
                <FormattedFloatingLabel controlId="consultrequest_preferredtime" label="When is a good time to call?">
                    <Form.Control type="text" placeholder="When is a good time to call?" value={preferredTime} onChange={e => { setPreferredTime(e.target.value); }}/>
                </FormattedFloatingLabel>
                <CheckboxRow className="mb-3" controlId="consultrequest_preferemail">
                    <Form.Check type="checkbox" label="I prefer emailing for now" checked={preferEmail} onChange={e => { setPreferEmail(!preferEmail); }}  />
                    <PhoneRequiredMessage className={preferEmail && "show"}><span>No problem! We're happy to answer questions about our services by email.</span> <span>Just note that at some point we'll need to have a call before booking a trip.</span></PhoneRequiredMessage>
                </CheckboxRow>
                <Form.Group controlId="consultrequest_message">
                    <FormLabel>Tell us a little about the trip you'd like to plan!<br />Do you have a destination or time of year in mind? How many people will travel?</FormLabel>
                    <Form.Control as="textarea" rows={3}  value={message} onChange={e => { setMessage(e.target.value); }} />
                </Form.Group>
                {submitErrorMessage!==null && <Error><FontAwesomeIcon icon={faExclamationTriangle} size="lg" /> <p>{submitErrorMessage} {submitErrorDetail && <span className="detail">{submitErrorDetail}</span>}</p></Error>}
                {validationErrorMessage!==null && <Error className="validation"><FontAwesomeIcon icon={faExclamationCircle} size="lg" /> <p>{validationErrorMessage}</p></Error>}
                <FormButton className="submit green" onClick={submitForm}>{isSendingForm===true ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />:"Send Request"}</FormButton>
                <FormButton className="gray inverse" onClick={cancelDialog}>Cancel</FormButton>
            </FormBody>
            <DoneBody className={formDone && "done"}>
                <p>Thanks for saying hi, we're looking forward to talking with you!</p>
                <p>Your request has been sent and we'll be reaching out to you soon. 
                    Just so you know it's us, we'll {preferEmail===true ? "email you from go@outward.travel":"call you from (720) 828-7665"}.</p>
                <FormButton className="green" onClick={closeDialog}>Close this Window</FormButton>
            </DoneBody> 
      </Modal.Body>
    </Modal>
  )
}






